import styled from "styled-components";
import {Colors} from "@shared/styles/colors";

const Layout = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: ${Colors.defaultBackgroundColor};
    padding: 24px;
    box-sizing: border-box;
`;

const Card = styled.div`
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${Colors.defaultContainerColor};
    border-radius: 20px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
    padding: 32px 24px;
`;

const Title = styled.div`
    font-size: 22px;
    font-family: Pretendard-Bold, emoji;
    color: ${Colors.boldTextColor};
    text-align: center;
`;

const Desc = styled.div`
    margin-top: 12px;
    font-size: 15px;
    line-height: 1.5;
    font-family: Pretendard-Medium, emoji;
    color: ${Colors.greyColor};
    text-align: center;
    white-space: pre-line;
`;

const PrimaryButton = styled.button`
    margin-top: 24px;
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 12px;
    background-color: ${Colors.primaryPurpleColor};
    color: ${Colors.defaultContainerColor};
    font-size: 16px;
    font-family: Pretendard-Bold, emoji;
    cursor: pointer;
    transition: transform 0.2s ease, opacity 0.2s ease;

    &:hover {
        opacity: 0.92;
    }

    &:active {
        transform: translateY(1px);
    }
`;

const StoreRow = styled.div`
    margin-top: 16px;
    display: flex;
    gap: 16px;
`;

const StoreLink = styled.a`
    font-size: 14px;
    font-family: Pretendard-Medium, emoji;
    color: ${Colors.primaryPurpleColor};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const s = {
    Layout,
    Card,
    Title,
    Desc,
    PrimaryButton,
    StoreRow,
    StoreLink,
};
